import React, { PropsWithChildren, useContext } from "react";

const ViewPropsContext = React.createContext<any>(undefined);
ViewPropsContext.displayName = "ViewProps";

interface ViewPropsProviderProps<T = any> extends PropsWithChildren {
  /**
   * View props
   */
  data: T;
}

/**
 * Provide context to propagate view props
 */
export const ViewPropsProvider = <T extends any = any>({ children, data }: ViewPropsProviderProps<T>) =>
  <ViewPropsContext.Provider value={data}>{children}</ViewPropsContext.Provider>;

/**
 * Provide function for get props of view
 */
export function useViewProps<T = any>(): T {
  return useContext(ViewPropsContext);
}
